/* istanbul ignore next */
const styles = ({ palette: { primary, text }, spacing: { unit } }) => ({
  workflow: {
    margin: unit * 8
  },
  list: {
    listStyleType: 'none',
    display: 'flex',
    padding: 0
  },
  description: {
    paddingLeft: unit * 1.25,
    fontSize: unit * 1.75,
    color: text.dark,
    textDecoration: 'none solid rgb(51, 51, 51)'
  },
  wrapper: {
    marginTop: unit * 8
  },
  approve: {
    marginRight: unit * 3
  },
  alert: {
    '& svg': {
      fill: 'rgb(0, 112, 185)'
    }
  },
  animatingButton: {
    transitionTimingFunction: 'cubic-bezier(0, 0.25, 1)',
    position: 'relative',
    overflow: 'hidden',
    zIndex: '1',
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: '0',
      left: '0',
      width: '100%',
      height: '100%',
      borderRadius: '10rem',
      zIndex: '-2'
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      bottom: '0',
      left: '0',
      width: '0%',
      height: '100%',
      backgroundColor: primary.darkBackground,
      transition: 'all 0s',
      transitionTimingFunction: 'cubic-bezier(0, 0.25, 1)',
      borderRadius: '10rem',
      zIndex: '-1'
    },
    '&.animating': {
      color: '#fff',
      '&:before': {
        transition: 'all 1s',
        width: '100%'
      }
    }
  }
});

export default styles;
